<template>
<svg class="cnm-icon" width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 2.8667L15.3301 10.3667H6.66987L11 2.8667Z" fill="black"/>
<path d="M11 20.8667L6.66987 13.3667L15.3301 13.3667L11 20.8667Z" fill="black"/>
</svg>
</template>